import { Injectable } from "@nestjs/common";
import { EntityRepository, Repository } from "typeorm";
import { PayrollComponentsLogs } from "../entity/payroll-process-logs.entity";


@Injectable()
@EntityRepository(PayrollComponentsLogs)
export class PayrollComponentLogsRepository extends Repository<PayrollComponentsLogs> {

    constructor() {
        super();
    }
}